import {
	faCircleCheck,
	faCircleInfo,
	faCircleXmark,
	faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { FontAwesomeIconWrapper } from '../../components/FontAwesomeIconWrapper';
import { cn } from '../../components/Element';
import { Row } from '../../components/Flex';
import {
	type BannerProps,
	VARIANT,
} from './bannerConstants';


export const Banner = ({
	text,
	variant = VARIANT.INFO,
}: BannerProps): React.JSX.Element | null => {
	if (!text) return null;
	return (
		<Row
			borderColor={
				variant === VARIANT.WARNING ? 'feedbackWarningDefault'
					: variant === VARIANT.ERROR ? 'feedbackErrorDefault'
						: variant === VARIANT.SUCCESS ? 'feedbackSuccessDefault'
							: 'feedbackInfoDefault'
			}
			bgColor={
				variant === VARIANT.WARNING ? 'surfaceFeedbackWarningDefault'
					: variant === VARIANT.ERROR ? 'surfaceFeedbackErrorDefault'
						: variant === VARIANT.SUCCESS ? 'surfaceFeedbackSuccessDefault'
							: 'surfaceFeedbackInfoDefault'
			}
			className='border-solid border-x-[0px] border-y gap-sm items-center justify-center'
			padding={{
				block: 'md',
				inline: 'sm',
			}}
			textSize='md'
			weight='bold'
		>
			<FontAwesomeIconWrapper
				className={cn({
					color: variant === VARIANT.WARNING ? 'borderFeedbackWarningDefault'
						: variant === VARIANT.ERROR ? 'borderFeedbackErrorDefault'
							: variant === VARIANT.SUCCESS ? 'borderFeedbackSuccessDefault'
								: 'borderFeedbackInfoDefault',
				})}
				icon={
					variant === VARIANT.WARNING ? faTriangleExclamation
						: variant === VARIANT.ERROR ? faCircleXmark
							: variant === VARIANT.SUCCESS ? faCircleCheck
								: faCircleInfo
				}
			/>
			{text}
		</Row>
	);
};
